import Colors, { getColorScheme } from "core/constants/colors";
import { ReactNode } from "react";
import { ThemeProvider } from "styled-components";

import { useOrganization } from "@/utils/api/useOrganization";
import { Organization } from "@/utils/fetcher/organization";

export const StyleComponentThemeProvider = ({
  organization,
  children,
}: {
  organization?: Organization;
  children: ReactNode;
}) => {
  const colorSchemePrimary = getColorScheme(organization?.themes?.colors?.primary);
  const colorSchemeSecondary = getColorScheme(organization?.themes?.colors?.secondary);

  return (
    <ThemeProvider
      theme={{
        colors: {
          ...Colors,
          primary: {
            ...colorSchemePrimary,
          },
          secondary: {
            ...colorSchemeSecondary,
          },
        },
        designStyle: organization?.design_style,
        fontStyle: organization?.landing_page_attributes?.font_style,
        buttonStyle: organization?.landing_page_attributes?.button_style,
      }}>
      {children}
    </ThemeProvider>
  );
};

function ThemeProviders({ children }: { children: ReactNode }) {
  const { organization } = useOrganization();

  return (
    <StyleComponentThemeProvider organization={organization}>
      {children}
    </StyleComponentThemeProvider>
  );
}

export default ThemeProviders;
